/** @format */

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomBox from "./CustomBox";
import InputBox from "./InputBox";
import EraseBox from "./EraseBox";
import ImageBox from "./ImageBox";
import { toggleSingleClick } from "../../../store/reducers/pdfeditor/singleClickSlice";
import ShapeBox from "./ShapeBox";

const BoxLayout = ({ pageIndex, scale, setShowCustomCursor, dimensions }) => {
  const { coordinates } = useSelector((state) => state.pdfCoordinates || []);
  const dispatch = useDispatch();
  const { dragToggleButton, textToggleButton } = useSelector(
    (state) => state.toolsModification || []
  );
  const { singleClick } = useSelector((state) => state.singleClickSl || []);
  console.log("single click value", singleClick);
  const [specialField, setSpecialField] = useState(false);
  const [multiField, setMultiField] = useState(false);

  // To make sjda type functionality start
  const [selectedBoxId, setSelectedBoxId] = useState(null);
  console.log("all coordinates are...............", coordinates);
  const handleSelectBox = (id) => {
    setSelectedBoxId(id);
    // if(id && !singleClick){

    //   dispatch(toggleSingleClick(true))
    // }
  };
  // To make sjda type functionality end

  return (
    <>
      {coordinates?.map((coord, idx) => {
        if (coord.pageNumber === pageIndex) {
          return (
            <div
              onMouseEnter={() => setShowCustomCursor(false)}
              onMouseLeave={() => setShowCustomCursor(true)}
              key={idx}
            >
              {coord?.addTextBox ? (
                <InputBox
                  key={coord?.id}
                  enableDargging={dragToggleButton}
                  coordinate={coord}
                  scale={scale}
                  dimensions={dimensions}
                  isSelected={selectedBoxId === coord.id}
                  onSelect={() => handleSelectBox(coord.id)}
                  setSelectedBoxId={setSelectedBoxId}

                  // clickFlag={clickFlag}
                  // setClickFlag={setClickFlag}
                />
              ) : coord?.eraserBox ? (
                <EraseBox
                  enableDargging={dragToggleButton}
                  coordinate={coord}
                  scale={scale}
                  dimensions={dimensions}
                  key={coord?.id}
                  isSelected={selectedBoxId === coord.id}
                  onSelect={() => handleSelectBox(coord.id)}
                  setSelectedBoxId={setSelectedBoxId}

                  // clickFlag={clickFlag}
                  // setClickFlag={setClickFlag}
                />
              ) : coord?.addImageBox ? (
                <ImageBox
                  enableDargging={dragToggleButton}
                  coordinate={coord}
                  scale={scale}
                  dimensions={dimensions}
                  key={coord?.id}
                  isSelected={selectedBoxId === coord.id}
                  onSelect={() => handleSelectBox(coord.id)}
                  setSelectedBoxId={setSelectedBoxId}
                />
              ) : coord?.shapeBox ? (
                <ShapeBox
                  key={coord?.id}
                  enableDargging={dragToggleButton}
                  coordinate={coord}
                  scale={scale}
                  dimensions={dimensions}
                  isSelected={selectedBoxId === coord.id}
                  onSelect={() => handleSelectBox(coord.id)}
                  setSelectedBoxId={setSelectedBoxId}
                />
              ) : (
                <CustomBox
                  key={coord?.id}
                  enableDargging={dragToggleButton}
                  addText={textToggleButton}
                  setShowCustomCursor={setShowCustomCursor}
                  coordinate={coord}
                  scale={scale}
                  dimensions={dimensions}
                  specialField={specialField}
                  setSpecialField={setSpecialField}
                  multiField={multiField}
                  setMultiField={setMultiField}
                  isSelected={selectedBoxId === coord.id}
                  onSelect={() => handleSelectBox(coord.id)}
                  setSelectedBoxId={setSelectedBoxId}
                />
              )}
            </div>
          );
        }
        return null;
      })}
      {specialField && (
        <>
          <div
            style={{
              width: dimensions?.width * 0.07,
              borderLeft: "2px dotted black",
              position: "absolute",
              right: 0,
              top: 0,
              height: "100%",
              background: "rgba(0,0,0,0.3)",
              // zIndex:4,
            }}
          ></div>
          <div
            style={{
              height: dimensions?.height * 0.07,
              borderTop: "2px dotted black",
              position: "absolute",
              left: 0,
              bottom: 56,
              width: "100%",
              background: "rgba(0,0,0,0.3)",
              // zIndex:4,
            }}
          ></div>
        </>
      )}
    </>
  );
};

export default BoxLayout;
